import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import useFormValidator from 'useFormValidator';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import moment from 'moment';
import * as actions from '../action';
import * as c from '../constant';

function CreateCalendaryEntryModal({
  createCalendarEntries,
  getCalendarEntriesList,
  showCalendarEntry,
  creating,
}) {
  const [formData, setFormData] = useState({
    type: '',
    description: '',
    title: '',
    date: '',
  });
  const validateForm = useFormValidator(formData, {
    type: 'required',
    description: 'required',
    title: 'required',
    date: 'required',
  });
  const setModal = useContext(ModalContext);

  const handleOnChangeDate = (key) => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (!validateForm.response.is_passed) {
      return false;
    }

    const args = {
      ...formData,
      date: moment(formData.date).format('YYYY-MM-DD'),
    };

    return createCalendarEntries(args, ({ data }) => {
      setModal({ isOpen: false });
      getCalendarEntriesList();
      // history.push(`/usermanagement/${_.get(data, 'id')}`);

      showCalendarEntry(data.id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Title: {validateForm.renderMessage('title')}
            </label>
            <input
              className="form-control"
              type="text"
              name="title"
              onChange={onChange}
              value={_.get(formData, 'title')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Description: {validateForm.renderMessage('description')}
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Type: {validateForm.renderMessage('type')}
            </label>
            <input
              className="form-control"
              type="text"
              name="type"
              onChange={onChange}
              value={_.get(formData, 'type')}
            />
          </div>

          <div className="form-input-group col-12 col-md-12">
            <label
              htmlFor="last_name"
              className="form-control-plaintext text-muted"
            >
              Date: {validateForm.renderMessage('date')}
            </label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('date')}
              value={_.get(formData, 'date') || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateCalendaryEntryModal.propTypes = {
  getCalendarEntriesList: PropTypes.instanceOf(Function).isRequired,
  createCalendarEntries: PropTypes.instanceOf(Function).isRequired,
  // history: PropTypes.instanceOf(Object).isRequired,
  showCalendarEntry: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_CALENDAR_ENTRIES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateCalendaryEntryModal);
